


























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { IClient } from "@/models/clients";

@Component({
  components: {
    "change-password-form": () =>
      import("@/components/app/global/auth/changePasswordForm.vue"),
    "two-factor-auth-form": () =>
      import("@/components/app/global/auth/twoFactorAuthForm.vue"),
    "client-login": () =>
      import(
        "@/components/app/global/client/settings/clientDetails/clientLogin.vue"
      )
  }
})
export default class Security extends Vue {
  @Prop({ required: true })
  public client!: IClient;
}
